import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';

import { Pulldown } from 'jbc-front/components/icons';
import { openNewTab } from 'src/utils/Http';
import ExportPndModalContainer from '../containers/ExportPndModalContainer';
import ExportSsoModalContainer from '../containers/ExportSsoModalContainer';
import styles from './ActionSection.scss';
import { withTranslation } from 'react-i18next';

const ExportDocumentMethod = onClickOutside(
  class extends Component {
    handleClickOutside = () => {
      this.props.hide();
    };

    constructor(props) {
      super(props);

      this.state = {
        isPndModalOpen: false,
        isSsoModalOpen: false
      };

      this.openPndModal = this.openPndModal.bind(this);
      this.openSsoModal = this.openSsoModal.bind(this);
      this.closePndModal = this.closePndModal.bind(this);
      this.closeSsoModal = this.closeSsoModal.bind(this);
    }

    openPndModal() {
      if (this.state.isPndModalOpen) return;
      this.setState({ ...this.state, isPndModalOpen: true });
    }

    openSsoModal() {
      if (this.state.isSsoModalOpen) return;
      this.setState({ ...this.state, isSsoModalOpen: true });
    }

    closePndModal() {
      if (!this.state.isPndModalOpen) return;
      this.setState({ ...this.state, isPndModalOpen: false });
    }

    closeSsoModal() {
      if (!this.state.isSsoModalOpen) return;
      this.setState({ ...this.state, isSsoModalOpen: false });
    }

    render() {
      const { isConfirmed, isOpen } = this.props;

      return (
        <React.Fragment>
          <div className={isOpen ? styles.baloonWrap : styles.hide}>
            <div className={styles.baloonThird}>
              <ul className={styles.links}>
                {/* <li>
                  <a
                    onClick={() => this.openPndModal()}
                    className={isConfirmed ? undefined : styles.disabled}
                    role="presentation"
                  >
                    <Pulldown size={8} />{this.props.t('features.EmployeePays.components.ExportDocumentMethod.Export_data_required_for_online_PND1_submission')}
                  </a>
                </li> */}
                <li>
                  <a
                    onClick={() => this.openSsoModal()}
                    className={isConfirmed ? undefined : styles.disabled}
                    role="presentation"
                  >
                    <Pulldown size={8} />{this.props.t('features.EmployeePays.components.ExportDocumentMethod.Data_Export_for_Social_Security_Submission')}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <ExportPndModalContainer isOpen={this.state.isPndModalOpen} hideModal={this.closePndModal} />
          <ExportSsoModalContainer isOpen={this.state.isSsoModalOpen} hideModal={this.closeSsoModal} />
        </React.Fragment>
      );
    }
  }
);

export default withTranslation()(ExportDocumentMethod);
